export default __webpack_public_path__ + "static/media/percent.68182b4e.svg";